import {
  createConsumer
} from '@rails/actioncable';

angular.module('actionCable', []).factory('ActionCable', ["$rootScope", "$timeout", function($rootScope, $timeout) {
  return {
    create: function(params, callback) {
      var data, disconnect, enabled, url;
      enabled = $rootScope.gym.use_action_cable;
      url = $('meta[name=action-cable-url]').attr('content');
      data = {};
      $timeout(function() {
        if (enabled) {
          data.consumer = createConsumer(url);
          return data.consumer.subscriptions.create(params, {
            received: function(message) {
              return callback(message);
            }
          });
        }
      });
      disconnect = function() {
        var ref;
        return (ref = data.consumer) != null ? typeof ref.disconnect === "function" ? ref.disconnect() : void 0 : void 0;
      };
      return disconnect;
    }
  };
}]);
